import { getAxiosClient } from "../axios";

export const SendMessage = async (message) => {
  const axiosClient = await getAxiosClient();

  return await axiosClient
    .put(`/contact`, message)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};

export const SendDemoMessage = async (message) => {
  const axiosClient = await getAxiosClient();

  return await axiosClient
    .put(`/demo`, message)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};

